import { ElMessage } from 'element-plus'

export function copyToClipboard(text: string, message = '复制成功') {
  return navigator.clipboard
    .writeText(text)
    .then(() => {
      ElMessage.success(message)
    })
    .catch(() => {
      ElMessage.warning('环境不安全，请手动复制 ' + text)
    })
}

export function sleep(ms: number) {
  console.log('sleep')
  return new Promise((resolve) => setTimeout(resolve, ms))
}
